/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { ApiQuery } from '@app/core/http/api-query';
import { Logger } from '@app/core';
import { LocalesService } from '@app/settings/locales/locales.service';
import { LocalesFormService } from '@app/settings/locales/locales-form.service';
import { Locale } from '@app/settings/locales/locales.model';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';

const log = new Logger('localesListComponent');

@Component({
  selector: 'app-locales-list',
  templateUrl: './locales-list.component.html',
  styleUrls: ['./locales-list.component.scss'],
})
export class LocalesListComponent extends KendoGridComponent implements OnInit {
  localesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private localeService: LocalesService,
    private localesFormService: LocalesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('LocalesListComponent');

    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);

    this.localeService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.localesResponse = response;
      this.data = response.getGridData();

      log.debug('loadData', this.data);
    });

    CustomKendoFilter.pushStateInStorage('LocalesListComponent', this.state);
  }

  add() {
    this.localesFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param locale Locale object
   */
  edit(locale: Locale) {
    this.localesFormService.open(locale);
  }

  /**
   *
   * @param locale Locale object
   */
  delete(locale: Locale) {
    this.localeService.destroy(locale.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
